/** Ushers: pick the election to check voters in (they cannot open the elections list) */

import { Link, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { CalendarDays, Loader2, Lock, UserCheck } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { listCheckinElections } from '../data/votingRepository';
import { votingErrorMessage } from '../utils/votingErrors';

export function CheckinListPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['voting', 'checkin-elections'],
    queryFn: listCheckinElections,
    refetchInterval: 15_000,
  });

  if (isLoading) return <div className="flex justify-center py-16"><Loader2 className="size-6 animate-spin text-muted-foreground" /></div>;
  if (error) return <p className="p-6 text-destructive">{votingErrorMessage(error)}</p>;

  const open = (data ?? []).filter((e) => !e.started);
  if (data?.length === 1 && open.length === 1) return <Navigate to={`/voting/${open[0].id}/checkin`} replace />;

  return (
    <div className="mx-auto max-w-lg space-y-4 p-4">
      <header>
        <h1 className="flex items-center gap-2 text-xl font-bold"><UserCheck className="size-5" /> Habilitar votantes</h1>
        <p className="text-sm text-muted-foreground">Elija la elección. Escaneará la credencial de cada votante antes de la votación.</p>
      </header>
      {(data ?? []).length === 0 ? (
        <Card><CardContent className="py-10 text-center text-sm text-muted-foreground">No hay elecciones con registro previo en curso.</CardContent></Card>
      ) : (
        <div className="space-y-3">
          {(data ?? []).map((e) => (
            <Link key={e.id} to={`/voting/${e.id}/checkin`} className="block">
              <Card className="transition-colors hover:bg-muted/40">
                <CardContent className="space-y-1 p-4">
                  <div className="flex items-start justify-between gap-2">
                    <h2 className="font-semibold">{e.name}</h2>
                    {e.started && <Badge variant="secondary" className="gap-1"><Lock className="size-3" /> Cerrado</Badge>}
                  </div>
                  {e.event_name && <p className="flex items-center gap-1.5 text-sm text-muted-foreground"><CalendarDays className="size-4" /> {e.event_name}</p>}
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
